import { cva } from 'class-variance-authority';
import Image from 'next/image';
import React from 'react';

import { colors } from '@Components/design-system/color-v2';
import { PaletteType, StrokePalette } from '@Components/design-system/color-v2/types';

export interface IconProps {
  size: 'xxs' | 'xs' | 's' | 'm' | 'l' | 'xl';
  weight?: number;
  name: string;
  onClick?: (event?: React.MouseEvent<HTMLSpanElement>) => void;
  color?: PaletteType | StrokePalette;
  fill?: boolean;
  src?: 'google' | 'internal';
}

const Icon = ({ size, name, fill = false, color, onClick, src = 'google' }: IconProps) => {
  const sizeMap = {
    xxs: 16,
    xs: 20,
    s: 24,
    m: 28,
    l: 32,
    xl: 44,
  };

  const iconSize = sizeMap[size] || 24;
  return (
    <span
      onClick={onClick}
      style={{
        color: Object.keys(StrokePalette).includes(color) ? colors.stroke[color] : colors.palette[color],
        fontVariationSettings: fill ? "'FILL' 1" : "'FILL' 0",
      }}
      className={IconContainer({ size })}>
      {src === 'google'
        ? name
        : src === 'internal' && <Image src={name} alt={name} width={iconSize} height={iconSize} />}
    </span>
  );
};

export default Icon;

const IconContainer = cva(
  ['material-symbols-rounded relative flex items-center justify-center cursor-pointer gap-1 aspect-square'],
  {
    variants: {
      size: {
        xxs: '!text-[16px] w-4 h-4',
        xs: '!text-[20px] w-5 h-5',
        s: '!text-[24px] w-6 h-6',
        m: '!text-[28px] w-7 h-7',
        l: '!text-[32px] w-8 h-8',
        xl: '!text-[44px] w-11 h-11',
      },
    },
    defaultVariants: {
      size: 's',
    },
  },
);
